import { Injectable } from '@angular/core';
import { GetPreferredResult, GetResult, SetOptions, TextZoom } from '@capacitor/text-zoom';

@Injectable({
  providedIn: 'root'
})
export class TextZoomWrapper {
  constructor() {}

  get(): Promise<GetResult> {
    const getPromise = TextZoom.get();
    return getPromise;
  }

  getPreferred(): Promise<GetPreferredResult> {
    const getPreferredPromise = TextZoom.getPreferred();
    return getPreferredPromise;
  }

  set(options: SetOptions): Promise<void> {
    const setPromise = TextZoom.set(options);
    return setPromise;
  }
}